// src/utils/questionNormalize.js

export function parseJson(value, fallback) {
  if (value == null) return fallback;

  // already correct-ish type
  if (typeof value === "object") return value;

  if (typeof value === "string") {
    const s = value.trim();
    if (!s) return fallback;

    try {
      const parsed = JSON.parse(s);
      return parsed ?? fallback;
    } catch {
      return fallback;
    }
  }

  return fallback;
}

export function normalizeMatchingItems(raw) {
  const fallback = { left: ["", ""], right: ["", ""] };
  const obj = parseJson(raw, fallback);

  const left = Array.isArray(obj?.left) ? obj.left.map(v => String(v ?? "")) : [...fallback.left];
  const right = Array.isArray(obj?.right) ? obj.right.map(v => String(v ?? "")) : [...fallback.right];

  // ensure minimum 2
  while (left.length < 2) left.push("");
  while (right.length < 2) right.push("");

  return { left, right };
}

export function normalizeMatchingPairs(raw) {
  const fallback = [{ left_index: null, right_index: null }];
  const arr = parseJson(raw, fallback);

  if (!Array.isArray(arr)) return [...fallback];

  const cleaned = arr
    .filter(x => x && typeof x === "object")
    .map(x => ({
      left_index: x.left_index === null || x.left_index === undefined ? null : Number(x.left_index),
      right_index: x.right_index === null || x.right_index === undefined ? null : Number(x.right_index),
    }));

  return cleaned.length ? cleaned : [...fallback];
}

// For MCQ / True-False after you switched correct_answer to JSON
// Always returns an array. If you want single-answer behavior, use arr[0].
export function normalizeCorrectAnswerArray(raw) {
  if (Array.isArray(raw)) return raw.map(v => (v == null ? "" : String(v)));

  if (typeof raw === "string") {
    const s = raw.trim();
    if (!s) return [];

    // if stringified array, decode it
    if (s.startsWith("[") || s.startsWith("{")) {
      const parsed = parseJson(s, null);
      if (Array.isArray(parsed)) return parsed.map(v => (v == null ? "" : String(v)));
    }

    // scalar string
    return [s];
  }

  if (raw == null) return [];
  return [String(raw)];
}

// Convenience: for single-answer MCQ / TF (returns a string)
export function normalizeCorrectAnswerSingle(raw) {
  const arr = normalizeCorrectAnswerArray(raw);
  return String(arr[0] ?? "").trim();
}
